import { useTranslation } from 'react-i18next';
import { Link, Outlet } from 'react-router-dom';
import { Anchor, Box, Flex, Group, useMantineTheme } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import Logo from '@/components/Logo';
import { ROUTES } from '@/routes/paths';
import classes from './AuthLayout.module.css';

// Экраны входа и регистрации («Бюллетень»): слева строка шапки с логотипом и выходом «← На сайт» и форма шириной
// 440 px, справа узкая фирменная фотография (28 %). Меню сайта здесь нет: человек занят одной задачей. Фотография
// закреплена и высотой в один экран — одинаковый кадр при любой длине формы. На телефоне фотографии нет.
export default function AuthLayout() {
  const { t } = useTranslation();
  const { headerHeight } = useMantineTheme().other;

  return (
    <Flex align="stretch" mih="100dvh">
      <Flex direction="column" flex="1" miw={0}>
        <header className={classes.bar} style={{ height: headerHeight }}>
          <Logo height={24} offsetY={-2} />
          <Anchor component={Link} to={ROUTES.HOME} className={classes.home} underline="never">
            <Group gap={6} wrap="nowrap">
              <IconArrowLeft size={18} aria-hidden />
              {t('auth.backToSite')}
            </Group>
          </Anchor>
        </header>
        <main className={classes.form}>
          <Outlet />
        </main>
      </Flex>

      <Box visibleFrom="md" w="28%" pos="relative">
        <div className={classes.photo} />
      </Box>
    </Flex>
  );
}
